import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";

const CalendarService = {
  removeStaleOauth: (payload: any) =>
    requests(SERVICE_NAME.AUTOMATION_CALENDARS_API).post(
      "remove-stale-oauth",
      payload
    ),

  deleteOrganicEntity: (entityId: string) =>
    requests(SERVICE_NAME.AUTOMATION_CALENDARS_API).log({
      module: Module.CALENDARS,
      entityType: EntityType.OTHERS,
      entityId: entityId,
    }).delete(
      `google-organic/entity/${entityId}`
    ),
};

export default CalendarService;
